import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import {
  NkEntry,
  NkContainer,
  NkStack,
} from '@/core/components';

import DeviceGroupRootEntry from '@/entities/device-group/components/DeviceGroupRootEntry.vue';
import NkInspectionGroupTable
  from '@/entities/inspection-group/components/InspectionGroupTable.vue';
import NkInspectionKeyFigure from '@/entities/inspection/components/InspectionKeyFigures.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'NkDashboard',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.$route.name === 'visionair-dashboard')
    ? (_openBlock(), _createBlock(_unref(NkContainer), {
        key: 0,
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkStack), { spacing: 8 }, {
            default: _withCtx(() => [
              _createVNode(DeviceGroupRootEntry),
              _createVNode(_unref(NkEntry), {
                title: _ctx.$t('misc.key_figures')
              }, {
                default: _withCtx(() => [
                  _createVNode(NkInspectionKeyFigure)
                ]),
                _: 1
              }, 8, ["title"]),
              _createVNode(_unref(NkEntry), {
                title: _ctx.$t('misc.inspections')
              }, {
                default: _withCtx(() => [
                  _createVNode(NkInspectionGroupTable, { "items-per-page-selection": true })
                ]),
                _: 1
              }, 8, ["title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
}
}

})